export default function OptimizerPricing() {
  const plans = [
    {
      name: '内部使用许可',
      price: '¥20,843',
      period: '/年',
      description: '适合企业内部使用的标准许可',
      features: [
        'Windows 64位支持',
        'Linux 64位支持',
        '命令行工具',
        '批量处理功能',
        '技术支持',
        '免费更新'
      ],
      popular: false
    },
    {
      name: 'OEM许可',
      price: '联系销售',
      period: '',
      description: '适合将产品集成到您的解决方案中',
      features: [
        '所有内部使用功能',
        '可再分发权限',
        '白标支持',
        '优先技术支持',
        '定制开发服务',
        '专属客户经理'
      ],
      popular: true
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            灵活的定价方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            选择适合您业务需求的许可方案
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`relative bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl ${
                plan.popular ? 'ring-2 ring-teal-500 transform scale-105' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-2 text-sm font-semibold rounded-bl-2xl">
                  推荐方案
                </div>
              )}
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {plan.name}
                </h3>
                <p className="text-gray-600 mb-6">
                  {plan.description}
                </p>
                
                <div className="mb-8">
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl font-bold text-gray-900">{plan.price}</span>
                    {plan.period && <span className="text-xl text-gray-600">{plan.period}</span>}
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="iconify i-material-symbols:check-circle w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" aria-hidden="true"></span>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  className={`block w-full text-center px-8 py-4 rounded-lg font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    plan.popular
                      ? 'bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white shadow-lg hover:shadow-xl'
                      : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                  }`}
                >
                  {plan.price === '联系销售' ? '联系销售' : '立即购买'}
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            需要其他平台支持？查看 <a href="/adobe-pdf-library" className="text-teal-600 hover:text-teal-700 font-semibold">Adobe PDF Library SDK</a> 了解更多选项，包括macOS、Solaris和AIX，或尝试我们的 <a href="/pdf-rest-container" className="text-teal-600 hover:text-teal-700 font-semibold">pdfRest API Toolkit Container</a>。
          </p>
        </div>
      </div>
    </section>
  );
}
